<template>
  <div class="cp-media-modal">
    <div class="layer" />
    <div class="modal-container">
      <button
        @click="onCloseModal"
        type="button"
        class="btn-close"
      >
        <svg class="icon icon-close-modal">
          <use xlink:href="#icon-close-modal"></use>
        </svg>
      </button>
      <perfect-scrollbar
        ref="ps"
        :options="scrollOptions"
      >
        <div
          class="modal-content"
          :class="media.format"
        >
          <component
            :display-vodalys="displayVodalys"
            :type-player="typePlayer"
            :is="mediaComponent"
            :source="this.sources"
          />
          <div class="modal-title">
            {{ media.title }}
          </div>
          <div
            class="modal-description"
            v-html="media.description"
          />

          <div class="share">
            <div>{{ media.share_label }}</div>
            <a
              :href="`https://twitter.com/intent/tweet?url=${fixedEncodeURIComponent(media.permalink)}&text=${fixedEncodeURIComponent(media.title)}`"
              target="_blank"
              rel="noopener"
              aria-label=""
            >
              <span aria-hidden="true">
                <svg class="icon icon-media-twitter"><use xlink:href="#icon-media-twitter"></use></svg>
              </span>
            </a>
            <a
              :href="`https://www.linkedin.com/sharing/share-offsite/?url=${fixedEncodeURIComponent(media.permalink)}`"
              target="_blank"
              rel="noopener"
              :aria-label="media.title"
            >
              <span aria-hidden="true">
                <svg class="icon icon-media-linkedin"><use xlink:href="#icon-media-linkedin"></use></svg>
              </span>
            </a>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import MediaVideo from './Media/MediaVideo';
import SoundCloud from './Media/SoundCloud';
import MediaImage from './Media/MediaImage';

export default {
  components: {
    PerfectScrollbar,
  },
  props: {
    source: {
      type: [String, Array],
      required: true,
    },
    media: {
      type: Object,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      scrollOptions: {
        suppressScrollX: true,
        wheelPropagation: false,
      },
      mediaFormats: {
        video: MediaVideo,
        podcast: SoundCloud,
        image: MediaImage,
      },
      sources: this.source,
    }
  },
  computed: {
    mediaComponent() {
      return this.mediaFormats[this.media.format];
    },
  },
  methods: {
    onCloseModal() {
      this.$emit('close-modal');
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);
    },
  },
}
</script>
